/**
 * Help engine error codes (epic PI-SPEC-SW-E302, ER-1655, contract help 1).
 *
 * What the SpecTree Toolbox help engine reports when it cannot answer a
 * question. Bridge actions return them on failure and the `turn-finished`
 * event carries them; the Help panel maps them to plain messages and keeps
 * the person's typed question so it can be asked again.
 */
/** Every code the help engine reports. */
export const HELP_ENGINE_ERROR_CODES = [
    "CLAUDE_NOT_INSTALLED",
    "CLAUDE_NOT_SIGNED_IN",
    /** The bundled plugin with the `toolbox-help` skill, or the help pack, is missing. */
    "PLUGIN_MISSING",
    "MCP_NOT_CONNECTED",
    /** The person's Claude usage limit is reached; the message names the reset time. */
    "USAGE_LIMIT",
    "NETWORK",
    /** The app is already answering a help question (one help turn at a time per app). */
    "BUSY",
    /** Claude finished without a valid `SPECTREE_HELP_TURN` line for this conversation. */
    "NO_TURN_RETURNED",
    "TURN_TIMEOUT",
    /** A screenshot is above `HELP_IMAGE_BYTES_MAX` or not an accepted image type. */
    "IMAGE_TOO_LARGE",
    /** More than `HELP_IMAGES_MAX` screenshots. */
    "TOO_MANY_IMAGES",
    /** The person stopped the turn. */
    "STOPPED",
    "UNKNOWN",
];
/** True when `value` is a help engine error code. */
export function isHelpEngineErrorCode(value) {
    return typeof value === "string" && HELP_ENGINE_ERROR_CODES.includes(value);
}
//# sourceMappingURL=errors.js.map